var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex-center mt-2"},[_c('button',{staticClass:"btn btn-primary btn-round",attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }